/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {endChat} from '../api'

export const useMutationEndChat = createReactQueryMutationHook('endChat', endChat)
